"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var status = ['waiting_payment', 'authorized', 'cancelled', 'chargedback', 'chargedback_refund', 'analyzing', 'refunded', 'pending_refund', 'unavailable', 'paid', 'processing', 'refused', 'pending_review', 'suspended'];
var _default = exports["default"] = status;
module.exports = exports["default"];